import { useBooleanState } from '@calendly/hooks';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState, forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useKeyboardShortcut } from 'hooks/useKeyboardShortcut';
import { EventTypesList } from './event_types_list';
import { Footer } from './footer';
import { Header } from './header';
const bodyIsPhoneCss = "bsaga3f";
const bodyCss = "b12p71cv";
const Body = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(bodyCss, {
    [bodyIsPhoneCss]: isPhone
  }, props.className)} />;
});
const scrollWrapperCss = "s1n72sgg";
const ScrollWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent = 'div',
    ...restProps
  } = props;
  return <AsComponent ref={ref} {...restProps} className={classNames(scrollWrapperCss, props.className)} />;
});
export const EventTypeSelectPopup = ({
  isOpen,
  onCancel,
  onEventTypeSelect,
  onCreateNewEventType,
  contact,
  defaultValue,
  actionKind = 'share_availability'
}) => {
  const {
    pathname
  } = useLocation();
  const containerRef = useRef(null);
  const [selectedET, setSelectedET] = useState();
  const [shouldShowStroke, showStroke, hideStroke] = useBooleanState(false);
  const onConfirmSelection = useCallback(() => {
    onEventTypeSelect(selectedET);
    setSelectedET(null);
  }, [onEventTypeSelect, selectedET]);
  const onCloseModal = useCallback(() => {
    setSelectedET(null);
    onCancel();
  }, [onCancel]);
  useEffect(() => {
    setSelectedET(defaultValue);
  }, [defaultValue]);
  useEffect(() => {
    if (isOpen) {
      document.activeElement?.blur();
    }
  }, [isOpen]);
  useKeyboardShortcut('Enter', onConfirmSelection, isOpen, true, () => !!selectedET);
  const handleCreateEventTypeClick = useCallback(event => {
    const isAlreadyOnEventTypesPage = pathname.includes('/scheduling/meeting_types');
    if (isAlreadyOnEventTypesPage) {
      event.preventDefault();
      onCloseModal();
      if (onCreateNewEventType) {
        onCreateNewEventType();
      }
    }
  }, [onCloseModal, onCreateNewEventType, pathname]);
  return <Modal isOpen={isOpen}>
      <Body>
        <Header actionKind={actionKind} onClose={onCloseModal} contact={contact} />
        <ScrollWrapper ref={containerRef}>
          <EventTypesList onSelect={et => {
          setSelectedET(et);
        }} selectedET={selectedET} actionKind={actionKind} showStroke={showStroke} hideStroke={hideStroke} onCreateEventTypeClick={handleCreateEventTypeClick} ref={containerRef} isOpen />
        </ScrollWrapper>
        <Footer onConfirm={onConfirmSelection} onCancel={onCloseModal} hasSelected={!!selectedET} withStroke={shouldShowStroke} />
      </Body>
    </Modal>;
};

require("./event_type_select_popup.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./event_type_select_popup.js");